// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eennM","tabsBox":"styles_tabsBox__3p6K6","createButton":"styles_createButton__2TUXN"};